import { useEffect } from "react";
import { useClickOutsideSearch } from "./use-click-outside-search";
import { useDesktopViewport } from "./use-desktop-viewport";
import { useMobileSearchFocus } from "./use-mobile-search-focus";
import { useSearchQuerySync } from "./use-search-query-sync";

export const useSearchOverlayLifecycle = ({
  searchRef,
  mobileSearchInputRef,
  keyRef,
  mobileOverlayOpen,
  autoOpenMobile,
  setSearch,
  setSearchInFocus,
  setMobileOverlayOpen,
}) => {
  const isDesktopViewport = useDesktopViewport();

  useClickOutsideSearch({ searchRef, keyRef, setSearchInFocus });
  useMobileSearchFocus({ mobileOverlayOpen, mobileSearchInputRef });
  useSearchQuerySync({ setSearch });

  useEffect(() => {
    if (!autoOpenMobile) return;
    setSearchInFocus(true);
    setMobileOverlayOpen(true);
  }, [autoOpenMobile, setSearchInFocus, setMobileOverlayOpen]);

  return {
    isDesktopViewport,
  };
};
